import { render } from "./UserDocuments.vue?vue&type=template&id=68b250e2"
import script from "./UserDocuments.vue?vue&type=script&lang=js"
export * from "./UserDocuments.vue?vue&type=script&lang=js"
script.render = render

export default script